import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import GallerySection from '../components/sections/GallerySection';
import AboutSection from '../components/sections/AboutSection';
import PromoVideoSection from '../components/sections/PromoVideoSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import OrderSection from '../components/sections/OrderSection';
import FAQSection from '../components/sections/FAQSection';
import ContactSection from '../components/sections/ContactSection';
import LocationSection from '../components/sections/LocationSection';

const Home = () => {
  React.useEffect(() => {
    const img = new Image();
    img.src = '/images/hero-cake.png';
  }, []);

  return (
    <>
      <Helmet>
        {/* Primary SEO */}
        <title>Nithuja Cakes | Custom Cakes in Kilinochchi (Paranthan)</title>
        <meta
          name="description"
          content="Nithuja Cakes is a home bakery in Paranthan, Kilinochchi, specializing in custom birthday, wedding, and celebration cakes. Freshly baked with premium ingredients and creative designs."
        />
        <meta
          name="keywords"
          content="Nithuja Cakes, Custom Cakes Kilinochchi, Paranthan Cakes, Home Bakery Kilinochchi, Birthday Cakes Kilinochchi, Wedding Cakes Kilinochchi"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph / Social Media */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Nithuja Cakes | Custom Cakes in Kilinochchi (Paranthan)"
        />
        <meta
          property="og:description"
          content="Beautiful handmade custom cakes for birthdays, weddings, and special occasions in Kilinochchi. Order your perfect cake from Nithuja Cakes."
        />
        <meta property="og:image" content="/images/social-preview.jpg" />
        <meta property="og:locale" content="en_LK" />

        {/* Favicon */}
        <link rel="icon" type="image/png" href="/images/logoCake.png" />
      </Helmet>

      <div className="bg-gray-50 text-gray-800 font-sans">
        <Navbar />
        <main>
          <HeroSection />
          <GallerySection />
          <PromoVideoSection />
          <AboutSection />
          <TestimonialsSection />
          <OrderSection />
          <FAQSection />
          <ContactSection />
          <LocationSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Home;
